import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const clientService = {
    getClientData,
    updateClient,
    addClient,
    deleteClient,
    linkClientToAccount
}

function getClientData() {
    return apiClient.get(`/client_data?all=true&with_accounts=true`, {
        headers: authHeader()}
    )
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function updateClient(client) {
    return apiClient.patch(`/client_data`, client,{
        headers: authHeader()}
    )
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function addClient(client) {
    return apiClient.post(`/client_data`,client,{
        headers: authHeader()}
    )
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function deleteClient(client) {
    return apiClient.delete(`/client_data/${client.clientDataId}`,{
        headers: authHeader()
    })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function linkClientToAccount(client, accountId) {
    return apiClient.post(`/client_account/${accountId}/client`,client,{
        headers: authHeader()
    })
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}